import type { IBanksListFilter } from '~/components/entity/bank/item/types'

export const banksListFilter: IBanksListFilter[] = [
  { title: 'widget.banks_page.filters.available_credits', type: 'credits_count' },
  { title: 'widget.banks_page.filters.available_deposits', type: 'deposits_count' },
  { title: 'widget.banks_page.filters.open_vacancies', type: 'vacancies_count' }
]

export default {
  banksListFilter
}
